"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountDuration = exports.TrialPeriodMode = exports.CompanyPreRegistrationStatus = void 0;
var CompanyPreRegistrationStatus;
(function (CompanyPreRegistrationStatus) {
    CompanyPreRegistrationStatus["PENDING"] = "pending";
    CompanyPreRegistrationStatus["REGISTERED"] = "registered";
    CompanyPreRegistrationStatus["CLAIMED"] = "claimed";
})(CompanyPreRegistrationStatus = exports.CompanyPreRegistrationStatus || (exports.CompanyPreRegistrationStatus = {}));
var TrialPeriodMode;
(function (TrialPeriodMode) {
    TrialPeriodMode["DEFAULT"] = "default";
    TrialPeriodMode["CUSTOM"] = "custom";
    TrialPeriodMode["NONE"] = "none";
})(TrialPeriodMode = exports.TrialPeriodMode || (exports.TrialPeriodMode = {}));
var DiscountDuration;
(function (DiscountDuration) {
    DiscountDuration["ONCE"] = "once";
    DiscountDuration["FOREVER"] = "forever";
    DiscountDuration["REPEATING"] = "repeating";
})(DiscountDuration = exports.DiscountDuration || (exports.DiscountDuration = {}));
